import { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import api, { API_BASE } from "@/lib/api";
import { useSite } from "@/contexts/SiteContext";

export default function Downloads() {
  const { sectionContent } = useSite();
  const c = sectionContent("downloads");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/public/downloads").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (!c) return null;
  // Fără materiale încărcate → secțiunea nu apare deloc (nu arătăm schele publicului)
  if (items.length === 0) return null;
  const resolve = (d) => d.external_url || (d.file_path ? `${API_BASE}/public/files?path=${encodeURIComponent(d.file_path)}` : "");

  return (
    <section data-testid="downloads-section" className="py-24 lg:py-32" style={{ background: "var(--ct-bg)" }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="gold-rule" />
            <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Resurse gratuite"}</span>
            <span className="gold-rule" />
          </div>
          <h2 data-el="title" data-field="title" className="font-serif text-4xl sm:text-5xl leading-tight">{c.title || "Descarcă gratuit"}</h2>
          {c.subtitle && <p data-el="subtitle" data-field="subtitle" className="text-base leading-relaxed mt-4" style={{ color: "var(--ct-text-muted)" }}>{c.subtitle}</p>}
        </div>

        {(
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((d, i) => {
              const url = resolve(d);
              return (
                <a key={d.id} href={url} target="_blank" rel="noreferrer" className="card-premium p-7 flex flex-col gap-4" data-testid={`download-${i}`}>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center shrink-0" style={{ background: "var(--ct-emerald)", border: "1.5px solid var(--ct-gold)" }}>
                      <FileText size={20} style={{ color: "var(--ct-gold)" }} />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-serif text-xl leading-tight">{d.title || "Material PDF"}</h3>
                      {d.author && <p className="text-xs mt-1" style={{ color: "var(--ct-text-dim)" }}>{d.author}</p>}
                    </div>
                  </div>
                  {d.description && <p className="text-sm leading-relaxed" style={{ color: "var(--ct-text-muted)" }}>{d.description}</p>}
                  <span className="mt-auto inline-flex items-center gap-2 text-sm font-medium" style={{ color: "var(--ct-link)" }}>
                    <Download size={14} /> <span data-field="download_label">{c.download_label || "Descarcă PDF"}</span>
                  </span>
                </a>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
